<template>
  <section class="free-video vh100">
    <video-controller
      :src="selectedCourse.videoUrl"
      :img="selectedCourse.imageM"
      :length="selectedCourse.videoDuration"
      @onplay="onplay"
      :is-ios="isWpsIos" />
    <div class="free-video-search-button"
      @click="handleNavigate('/free_video/search')"></div>
    <div class="free-video-scroller">
      <div class="free-video-scroller-mask"
        v-if="loading"
        @touchmove="handlePrevent($event)"></div>
      <ul class="free-video-list" ref="list">
        <free-video-item
          v-for="course in this.courseList"
          :key="course.id"
          :data-source="course"
          :active="course.id === selectedCourse.id"
          @select="handleSelectCourse" />
      </ul>
    </div>
    <div class="free-video-footer" ref="footer" >
      <img v-if="!isInApp"  @click="toPage()" src="../assets/images/free-video-bottom-button.png" alt="">
    </div>
  </section>
</template>

<script>
import os from '@edu-fe/os'
import VideoController from '../components/VideoController'
import FreeVideoItem from '../components/FreeVideoItem.vue'
import { mapState, mapActions, mapMutations } from 'vuex'
import { isxxx } from '@mixins'

export default {
  name: 'FreeVideo',
  components: {
    VideoController,
    FreeVideoItem
  },
  data () {
    return {
      loading: false, // 是否在加载课程列表
      selectedCourse: {}, // 当前选中播放的课程
      pageNo: 1, // 加载的数据页数
      cover: true
    }
  },
  computed: {
    ...mapState({courseList: state => state.freeVideo.courseList}),
  },
  mixins: [
    isxxx
  ],
  created () {

    this.fromWPSApp(this.$route.query.redirect)

    this.pageNo = 1
    this['freeVideo/resetCourseList']()

    this.getCourseList()
  },
  mounted () {
    // 设置滚动容器的高度
    const video = this.$el.querySelector('.video-mp4')
    const scroller = this.$el.querySelector('.free-video-scroller')

    this.$nextTick(() => {
      console.log(this.$refs.footer.offsetHeight)
      const scrollerHeight = document.body.clientHeight - video.offsetHeight - this.$refs.footer.offsetHeight
      console.log(document.body.clientHeight)
      scroller.style.height = `${scrollerHeight}px`

      scroller.addEventListener('scroll', this.throttle(() => {
        const { scrollTop, scrollHeight } = scroller
        if (
            Math.abs(this.lastVideoItem.getBoundingClientRect().top - document.documentElement.clientHeight) <= 5
            || scrollerHeight + scrollTop >= scrollHeight
          ) {
          this.callLoading()
        }
      }))
    })
  },
  methods: {
    ...mapActions([
      'freeVideo/getCourseList',
      'freeVideo/getCourseDetail'
    ]),
    ...mapMutations([
      'freeVideo/resetCourseList'
    ]),
    toPage () {
      this.$router.push({
        path: '/list',
        query: {
          category: 0,
          market: 'dairy_free'
        }
      })
    },
    fromWPSApp (flag) {
      if (parseInt(flag)) {
        this.$router.push({
          name: 'recommend',
          query: {
            redirect: 1,
            freeVideoId: this.$route.params.courseId
          }
        })
      }
    },

    callLoading () {
      if (!this.loading) {
        this.loading = !this.loading
        this.$loading.show()

        this.pageNo++
        this.getCourseList()

        setTimeout(() => {
          this.loading = !this.loading
          this.$loading.hide()
        }, 1000)
      }
    },
    throttle (action, interval = 500) {
      let timer

      return function () {
        clearTimeout(timer)
        timer = setTimeout(action, interval)
      }
    },
    handlePrevent (e) {
      e.preventDefault()
    },
    getCourseList () {
      this['freeVideo/getCourseList']({
        pageNo: this.pageNo
      }).then(() => {
        // 首次加载时判断是否有默认播放的视频
        if (this.pageNo === 1) {
          const courseId = this.$route.params.courseId

          // courseId传null默认加载第一项
          if (courseId && courseId !== 'null') {
            const targetCourse = this.courseList.filter(course => (course.id === courseId))[0]
            if (targetCourse) {
              this.selectedCourse = targetCourse
            } else {
              this.selectedCourse = {}

              // 查询搜索结果详情
              this['freeVideo/getCourseDetail'](courseId).then(course => (this.selectedCourse = course))
            }
          } else {
            this.selectedCourse = this.courseList[0]
          }
        }
      })
    },
    handleSelectCourse (course) {
      this.selectedCourse = course
      this.cover = true
    },
    handleNavigate (url) {
      if (typeof url === 'string') {
        this.$router.push(url)
      } else {
        const { path, name } = url
        this.$router.push({
          path, name
        })
      }
    },
    onplay () {
    }
  },

  updated () {
    this.lastVideoItem = this.$refs.list.lastChild
  }
}
</script>

<style lang="scss">
  @charset 'utf-8';
  @import "../style/main";

  $global-width: 750;

  .free-video {
    overflow: hidden;
    /*height: 100%;*/

    &-placeholder {
      height: rem($g-player);
    }

    &-scroller {
      overflow-y: scroll;
      position: relative;
      padding-bottom: rem(117);
      box-sizing: border-box;
      &-mask {
        opacity: 0;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1;
      }
    }

    &-search-button {
      padding: rem(16) rem(30);

      &::before {
        content: '';
        display: block;
        width: rem(690);
        height: rem(68);
        background-image: url('../assets/images/free-video-search-bg.png');
        background-repeat: no-repeat;
        background-size: cover;
      }
    }

    &-footer {
      position: fixed;
      bottom: rem(-5);
      left: 0;
      width: 100%;
      height: rem(118);
      img {
        width: 100%;
      }
    }
  }

  $global-width: 720;
</style>
